import { useNavigate } from 'react-router-dom';
import { AddOnGroupForm } from '../components/AddOnGroupForm';
import { useAddOnGroupMutations } from '../hooks/useAddOnGroupMutations';
import type { AddOnGroupFormValues } from '../schemas/addonGroup.schema';
import { Alert } from '@/shared/components';

export function AddOnGroupCreate() {
    const navigate = useNavigate();
    const { createMutation } = useAddOnGroupMutations();

    const handleSubmit = (data: AddOnGroupFormValues) => {
        createMutation.mutate(
            { name: data.name, description: data.description, addon_ids: data.addon_ids },
            { onSuccess: (created) => navigate(`/smr-admin/addon-groups/${created.id}`) },
        );
    };

    return (
        <section className="space-y-4">
            <h1 className="text-2xl font-semibold">New Optional Extra Group</h1>
            {createMutation.isError && (
                <Alert variant="error">
                    <span>{(createMutation.error as Error)?.message ?? 'Failed to create group.'}</span>
                </Alert>
            )}
            <AddOnGroupForm onSubmit={handleSubmit} isLoading={createMutation.isPending} submitLabel="Create Group" />
        </section>
    );
}
